import { useSearchParams } from 'react-router-dom';

export const useWorkstreamId = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get('workstreamId');
};
